import {
    getCateringFormats,
    GetCateringFormatsApiResponseSchema,
} from './get-catering-formats';
import {
    getCateringEventFormatsByCategoryUid,
    GetCateringEventFormatsByCategoryUidApiResponseSchema,
} from './get-catering-event-formats-by-category-uid';
import {
    getCateringEventCategories,
    GetCateringEventCategoriesApiResponseSchema,
} from './get-catering-event-categories';
import {
    getCateringService,
    GetCateringServiceActionResponseMapper,
} from './get-catering-service';

export {
    GetCateringFormatsApiResponseSchema,
    GetCateringEventFormatsByCategoryUidApiResponseSchema,
    GetCateringEventCategoriesApiResponseSchema,

    GetCateringServiceActionResponseMapper,
};

export const CateringPageActions = {
    getCateringFormats,
    getCateringEventFormatsByCategoryUid,
    getCateringEventCategories,
    getCateringService,
};
